import { format } from "date-fns";

export const formatShortDate = (date: Date | number): string => {
	return format(date, "PP");
};
